import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';

export const getInitialObjects = (): Promise<any> =>
  api()
    .get(`/portal-api/welcome/getInitialObjects`)
    .then((data) => get(data, 'data'))
    .catch((error) => Promise.reject());
